import { actionConstants } from './actionConstants';
import { get, post, put, _delete } from './method';
import noti from './toast';

export default {
  getBatchReports,
  getSpecificBatchReport,
  getBatchReportsByDept,
  createBatchReport,
  editBatchReport,
  deleteBatchReport,
  getProcesses,
  getSpecificProcess,
  createProcess,
  editProcess,
  deleteProcess,
};

function getBatchReports() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/batchReports?MaxResultCount=1000`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_BATCH_REPORTS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_BATCH_REPORTS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificBatchReport(batchId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/batchReports/${batchId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_BATCH_REPORT_SUCCESS,
          data: resp,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_BATCH_REPORT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getBatchReportsByDept(deptId) {
  return async (dispatch) => {
    return await get(`app/batchReports/by-department/${deptId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_BATCH_REPORTS_BY_DEPT_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_BATCH_REPORTS_BY_DEPT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function createBatchReport(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post('app/batchReports', params)
      .then((resp) => {
        noti.success('Batch report is created');
        dispatch({
          type: actionConstants.CREATE_BATCH_REPORT_SUCCESS,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_BATCH_REPORT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function editBatchReport(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await put(`app/batchReports/${_params.id}`, params)
      .then((resp) => {
        noti.success('Batch report is updated');
        dispatch({
          type: actionConstants.EDIT_BATCH_REPORT_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_BATCH_REPORT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function deleteBatchReport(batchId) {
  return async (dispatch) => {
    return await _delete(`app/batchReports/${batchId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.DELETE_BATCH_REPORT_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_BATCH_REPORT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getProcesses(batchId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(
      `app/batchProcess?BatchReportId=${batchId}&&MaxResultCount=1000`,
    )
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_BATCH_PROCESSES_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_BATCH_PROCESSES_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificProcess(processId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/batchProcess/${processId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_BATCH_PROCESS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_BATCH_PROCESS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function createProcess(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post('app/batchProcess', params)
      .then((resp) => {
        noti.success(`Process ${_params.process} has been created`);
        dispatch({
          type: actionConstants.CREATE_BATCH_PROCESS_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(`Creating process ${_params.process} failed`);
        dispatch({
          type: actionConstants.CREATE_BATCH_PROCESS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function editProcess(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await put(`app/batchProcess/${_params.id}`, params)
      .then((resp) => {
        noti.success('Batch report is updated');
        dispatch({
          type: actionConstants.EDIT_BATCH_REPORT_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_BATCH_REPORT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function deleteProcess(processId) {
  return async (dispatch) => {
    return await _delete(`app/batchProcess/${processId}`)
      .then((resp) => {
        noti.success('Batch process is deleted');
        dispatch({
          type: actionConstants.DELETE_BATCH_PROCESS_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_BATCH_PROCESS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}
